/**
 * Castle & Key Hero Slideshow
 * Auto-advance with dot navigation and touch/swipe support
 */
(function() {
  const slideshow = document.querySelector('[data-ck-slideshow]');
  if (!slideshow) return;

  const slides = slideshow.querySelectorAll('.ck-hero__slide');
  const dots = slideshow.querySelectorAll('.ck-hero__dot');
  if (slides.length <= 1) return;

  let current = 0;
  let interval;
  const INTERVAL_MS = 6000;

  function goToSlide(index) {
    slides[current].classList.remove('is-active');
    if (dots[current]) dots[current].classList.remove('is-active');

    current = (index + slides.length) % slides.length;

    slides[current].classList.add('is-active');
    if (dots[current]) dots[current].classList.add('is-active');
  }

  function startAutoAdvance() {
    interval = setInterval(function() {
      goToSlide(current + 1);
    }, INTERVAL_MS);
  }

  function resetAutoAdvance() {
    clearInterval(interval);
    startAutoAdvance();
  }

  // Dot navigation
  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      var index = parseInt(this.getAttribute('data-slide-index'), 10);
      goToSlide(index);
      resetAutoAdvance();
    });
  });

  // Touch/swipe support
  var touchStartX = 0;
  var touchEndX = 0;

  slideshow.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  slideshow.addEventListener('touchend', function(e) {
    touchEndX = e.changedTouches[0].screenX;
    var diff = touchStartX - touchEndX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        goToSlide(current + 1);
      } else {
        goToSlide(current - 1);
      }
      resetAutoAdvance();
    }
  }, { passive: true });

  startAutoAdvance();
})();
